export default {"src":"/_next/static/media/disasterRecoveryEasy.186bbd92.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};